<template>
  <el-dialog title="服务查询" center :visible.sync="isShow" width="90vw" top="8vh" :close-on-click-modal="false">
    <div class="w100">
      <Sift ref="sift" :sift-data="siftData" @change="initPage">
        <el-col :span="8" class="po-r tx-r">
          <el-button size="mini" @click="fetchList">刷新</el-button>
          <el-button type="success" size="mini" @click="download">导出</el-button>
          <el-button type="primary" size="mini" @click="initPage">查询</el-button>
        </el-col>
      </Sift>
    </div>

    <div class="w100 po-r pt20">
      <el-table class="w100 tx-c my-table" :data="list" stripe border height="calc(84vh - 250px)">
        <el-table-column align="center" label="序号" prop="orderNo" width="60px"></el-table-column>
        <el-table-column align="center" label="工作标题" prop="workTitle" width="200px"></el-table-column>
        <el-table-column align="center" label="服务名称" prop="serveName" width="200px"></el-table-column>
        <el-table-column align="center" label="主办部门" prop="hostDept" width="200px"></el-table-column>
        <el-table-column align="center" label="服务主题" prop="serveTitle" width="160px"></el-table-column>
        <el-table-column align="center" label="发起人姓名" prop="initiatorName" width="100px"></el-table-column>
        <el-table-column align="center" label="发起人学号/工号" prop="initiatorNo" width="120px"></el-table-column>
        <el-table-column align="center" label="发起人部门/学院" prop="initiatorDept" width="160px"></el-table-column>
        <el-table-column align="center" label="处理状态" prop="handleStatus" width="100px"></el-table-column>
        <el-table-column align="center" label="时长" width="150px">
          <template slot-scope="scope">
            {{ scope.row.totalTakeTime | costTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="评价" prop="appraiseScore" width="60px"></el-table-column>
      </el-table>
      <div class="w100 mt20 tx-r">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>
      <a class="none" ref="downloadExcel" :href="downloadUrl" target="_blank"></a>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import Sift from "@/components/sift/Sift";

export default {
  name: "ServeSearchView",
  components: {
    Sift
  },
  props: ["queryType"],
  data() {
    return {
      isShow: false,
      loading: false,

      pageNum: 1,
      pageSize: 20,
      total: 0,
      siftData: [],
      list: [],

      downloadUrl: ""
    };
  },
  created() {},
  computed: {
    ...mapState(["userToken"])
  },
  mounted() {
    // this.fetchSiftData();
  },
  methods: {
    fetchSiftData() {
      this.loading = true;

      this.$http
        .post(`serveCount/queryTitle`)
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.siftData = data.resData.siftData;
            this.siftData[this.siftData.length - 1].placeholder =
              "可输入姓名、学号、工号搜索";
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      this.loading = true;
      let obj = {};
      if (this.siftData.length) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      if (this.queryType) {
        obj.queryType = this.queryType;
      }

      this.$http
        .post(`serveCount/query`, JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.list = data.resData.list;
            this.total = data.resData.total;

            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    download() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.sift.clickSearchBtn();
      }
      if (this.queryType) {
        obj.queryType = this.queryType;
      }
      obj.token = this.userToken;

      this.downloadUrl = this.$pramsUrl.getUrl(obj, "serveCount/query/export");
      this.$nextTick(() => {
        this.$refs.downloadExcel.click();
      });
    },
    initPage() {
      this.pageNum = 1;
      this.list = [];
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    },
    showView() {
      this.isShow = true;
      if (!this.siftData.length) {
        this.fetchSiftData();
      }
    }
  }
};
</script>

<style scoped>
</style>
